var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stellar"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 40,
    cy: 34.988,
    rx: 35,
    ry: 23,
    stroke: "content"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.8,28.617A10.924,10.924,0,0,1,69,34.988c0,6.049-5.722,11.481-14.1,14.5",
    stroke: "content"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,34.988V47.835a13,13,0,0,0,4.778,10.08c7.637,6.225,18.353,10.1,30.222,10.1s22.585-3.873,30.222-10.1A13,13,0,0,0,75,47.835V34.988",
    stroke: "content"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40,
    x2: 40,
    y1: 67.632,
    y2: 58.344,
    stroke: "content"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.667,
    x2: 51.667,
    y1: 66.368,
    y2: 57.031,
    stroke: "content"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.333,
    x2: 63.333,
    y1: 62.25,
    y2: 52.988,
    stroke: "content"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.333,
    x2: 28.333,
    y1: 66.368,
    y2: 57.031,
    stroke: "content"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.667,
    x2: 16.667,
    y1: 62.447,
    y2: 57.719,
    stroke: "content"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.242,24l-31.28,9.861c-.225.071-.49-.056-.45-.217.985-3.959,6.222-6.991,12.523-6.991a18.946,18.946,0,0,1,2.908.224,4.517,4.517,0,0,0,2.016-.168l4.247-1.339c.441-.139.483-.554.062-.716A25.907,25.907,0,0,0,40.035,23C29.96,23,21.764,28.379,21.764,35c0,.178.017.357.03.535h-.009c.015.165-.124.32-.351.391h0l-.685.216c-.537.169-.878.526-.878.917V39.83c0,.3.476.5.887.367L59.251,28.061c.537-.169.878-.526.878-.917V24.371C60.129,24.071,59.653,23.874,59.242,24Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.758,45.988l31.28-9.861c.225-.071.49.056.45.217-.985,3.959-6.222,6.991-12.523,6.991a18.946,18.946,0,0,1-2.908-.224,4.517,4.517,0,0,0-2.016.168l-4.247,1.339c-.441.139-.483.554-.062.716A25.907,25.907,0,0,0,39.965,47c10.074,0,18.271-5.383,18.271-12,0-.178-.017-.357-.03-.535h.009c-.015-.165.124-.32.351-.391h0l.685-.216c.537-.169.878-.526.878-.917V30.162c0-.3-.476-.5-.887-.367L20.749,41.93c-.537.169-.878.526-.878.917v2.774C19.871,45.921,20.347,46.117,20.758,45.988Z",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.121a74718b58ea38d8c46638da08edea.svg";
export { ForwardRef as ReactComponent };